import React from "react";
import { Row, Col, Card } from 'antd';
import { motion } from "motion/react";

function Rulebook() {
    return (
      <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} style={{ padding: '0 50px'}}>
        <h1>
            LPI Rulebook
        </h1>
      <Row style={{ 'marginTop': '16px' }}>
        <Col span={24}>
          <Card style={{ textAlign: "center"}}>
  <div style={{ textAlign: "left"}}>
  <h1 style={{ marginTop: "0in", pageBreakBefore: "always" }}>
    <a name="_Toc171978573" />
      <font size={5} style={{ fontSize: "18pt" }}>
        Sommario (Table of Contents)
      </font>
  </h1>
  <div id="Table of Contents1" dir="ltr">
    <p style={{  marginBottom: "0.07in" }}>
      <a href="#_Toc171978574">
        1 – Generale (General)
      </a>
    </p>
    <p
      style={{
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978575">
        1.1. PREMESSA (INTRODUCTION)
      </a>
    </p>
    <p
      style={{
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978576">
          1.2. ANNO LPI E CALENDARIO (LPI YEAR)
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978577">
        <font face="Tahoma, sans-serif">
          1.3. RAPPORTI CON L'ESTERNO (LPI AND OTHER ENTITIES)
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978578">
        <font face="Tahoma, sans-serif">
          1.4. RISORSE FINANZIARIE (FINANCIAL RESOURCES)
        </font>{" "}
      </a>
    </p>
    <p style={{  marginBottom: "0.07in" }}>
      <a href="#_Toc171978579">
        <font face="Tahoma, sans-serif">
          <span lang="en-GB">2 – Direttivo LPI (LPI Executive Board)</span>
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978580">
        <font face="Tahoma, sans-serif">
          <span lang="en-GB">2.1. NOMINA (ELECTION)</span>
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978581">
        <font face="Tahoma, sans-serif">
          2.2. COORDINAMENTO LPI (LPI VOTING PROCESS)
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978582">
        <font face="Tahoma, sans-serif">
          2.3. PROVVEDIMENTI DISCIPLINARI (DISCIPLINARY ACTIONS)
        </font>{" "}
      </a>
    </p>
    <p style={{  marginBottom: "0.07in" }}>
      <a href="#_Toc171978583">
        <font face="Tahoma, sans-serif">
          3 – Leghe Affiliate LPI (LPI Leagues)
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978584">
        <font face="Tahoma, sans-serif">
          3.1. FONDARE UNA LEGA (START A LEAGUE)
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978585">
        <font face="Tahoma, sans-serif">3.1.1 Requisiti (Requirements)</font> 8
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978586">
        <font face="Tahoma, sans-serif">
          3.1.2 Referente e Staff di Lega (League Manager and their staff)
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978587">
        <font face="Tahoma, sans-serif">
          3.2 REGOLAMENTO INTERNO (LEAGUE RULEBOOK)
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978588">
        <font face="Tahoma, sans-serif">
          3.2.1 Assegnare un Bye (Award a Bye)
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978589">
        <font face="Tahoma, sans-serif">3.2.2 Calendario (Calendar)</font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978590">
        <font face="Tahoma, sans-serif">
          3.2.3 Adesione ad una Lega (Attend a League)
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978591">
        <font face="Tahoma, sans-serif">3.2.4 Formati (Formats)</font> 9
      </a>
    </p>
    <p style={{  marginBottom: "0.07in" }}>
      <a href="#_Toc171978592">
        <font face="Tahoma, sans-serif">
          <span lang="en-US">4 – Paupergeddon Events</span>
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978593">
        <font face="Tahoma, sans-serif">
          <span lang="en-US">4.1 PAUPERGEDDON ©</span>
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978594">
        <font face="Tahoma, sans-serif">
          4.1.1 Organizzatori (Event Organizer)
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978595">
        <font face="Tahoma, sans-serif">
          4.1.2 Modalità di accesso (Access fee)
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978596">
        <font face="Tahoma, sans-serif">
          4.1.3 Requisiti essenziali (Minimun requirements)
        </font>{" "}
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978597">
        <font face="Tahoma, sans-serif">4.1.4 Montepremi (Prize pool)</font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978598">
        <font face="Tahoma, sans-serif">
          <span lang="en-GB">4.2 PAUPER LEAGUE WORLD CUP (WCUP)</span>
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978599">
        <font face="Tahoma, sans-serif">
          4.2.1 Modalità di accesso (means of access)
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978600">
        <font face="Tahoma, sans-serif">4.2.2 World Cup Teams</font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978601">
        <font face="Tahoma, sans-serif">
          4.2.3 Modalità di calcolo del punteggio (Ranking)
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978602">
        <font face="Tahoma, sans-serif">4.2.4 Montepremi (Prize pool)</font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978603">
        <font face="Tahoma, sans-serif">4.3 TOP PAUPER PLAYER (TPP)</font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978604">
        <font face="Tahoma, sans-serif">
          4.3.1 Modalità di invito (Invitation ticket)
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978605">
        <font face="Tahoma, sans-serif">4.3.2 Montepremi (Prize pool)</font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978606">
        <font face="Tahoma, sans-serif">4.3.3 LPI Points</font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978607">
        <font face="Tahoma, sans-serif">
          <span lang="en-GB">4.4 COLOSSEUM TEAM TRIOS (CTT)</span>
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978608">
        <font face="Tahoma, sans-serif">
          <span lang="en-US">4.4.1 Regola d’oro (Golden rule)</span>
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978609">
        <font face="Tahoma, sans-serif">4.4.2 Montepremi (Prize pool)</font>
      </a>
    </p>
    <p style={{  marginBottom: "0.07in" }}>
      <a href="#_Toc171978610">
        <font face="Tahoma, sans-serif">
          <span lang="en-US">5 – Byes &amp; Road to Paupergeddon!</span>
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978611">
        <font face="Tahoma, sans-serif">
          <span lang="en-US">5.1 FASCE ATTRIBUZIONE (BYE THRESHOLD)</span>
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978612">
        <font face="Tahoma, sans-serif">
          5.2 TEMPISTICHE (DEADLINE FOR SUBMISSION)
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978613">
        <font face="Tahoma, sans-serif">
          <span lang="en-US">5.3 SEASON ACCORPATE (SKIP A SEASON)</span>
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978614">
        <font face="Tahoma, sans-serif">5.4 TRIAL PAUPERGEDDON</font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978615">
        <font face="Tahoma, sans-serif">
          5.5 LEGHE ESTERE (FOREIGN LEAGUES)
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978616">
        <font face="Tahoma, sans-serif">
          <span lang="en-US">
            5.6 STATUTI SPECIALI (SPECIAL STATUS LEAGUES)
          </span>
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978617">
        <font face="Tahoma, sans-serif">
          5.7 EVENTI SPECIALI (SPECIAL EVENTS)
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978618">
        <font face="Tahoma, sans-serif">5.8 PAUPERGEDDON BREAK</font>
      </a>
    </p>
    <p style={{  marginBottom: "0.07in" }}>
      <a href="#_Toc171978619">
        <font face="Tahoma, sans-serif">
          <span lang="en-US">6 – LPI Events</span>
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978620">
        <font face="Tahoma, sans-serif">
          <span lang="en-US">6.1 INTERNATIONAL PAUPER TOUR (IPT)</span>
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978621">
        <font face="Tahoma, sans-serif">
          6.1.1 Requisiti essenziali (Minimun requirements)
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978622">
        <font face="Tahoma, sans-serif">6.1.2 Montepremi (Prize pool)</font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978623">
        <font face="Tahoma, sans-serif">
          <span lang="en-US">6.1.3 SUPER IPT e BYE EXTRA</span>
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.19in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978624">
        <font face="Tahoma, sans-serif">6.2 PAUPER TRIO EVENT (PTE)</font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978625">
        <font face="Tahoma, sans-serif">
          6.2.1 Requisiti essenziali (Minimun requirements)
        </font>
      </a>
    </p>
    <p
      style={{
        
        marginLeft: "0.39in",
        marginBottom: "0.07in"
      }}
    >
      <a href="#_Toc171978626">
        <font face="Tahoma, sans-serif">6.2.2 Montepremi (Prize pool)</font>
      </a>
    </p>
    <p style={{  marginBottom: "0.07in" }}>
      <a href="#_Toc171978627">
        <font face="Tahoma, sans-serif">7 – Contatti (Contacts)</font>
      </a>
    </p>
    <p style={{  marginBottom: "0.07in" }}>
      <a href="#_Toc171978628">
        <font face="Tahoma, sans-serif">8 – FAQ</font>
      </a>
    </p>
  </div>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <br />
  </p>
  <h1
    className="western"
    style={{ marginTop: "0in", pageBreakBefore: "always" }}
  >
    <a name="_Toc171978574" />
    <font face="Tahoma, sans-serif">
      <font size={5} style={{ fontSize: "18pt" }}>
        1 – Generale (General)
      </font>
    </font>
  </h1>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978575" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        1.1. PREMESSA (INTRODUCTION)
      </font>
    </font>
  </h2>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Lega Pauper Italia promuove il “<b>gioco intelligente</b>”, in particolare il gioco di carte <b>Magic: the Gathering</b>, formato “<b>Pauper</b>”, articolando la propria attività di promozione attraverso l'operato
        delle Leghe Affiliate, coordinate da un Referente e il relativo Staff di Lega.
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Questa è una lista di nomi definiti nel documento:
      </font>
    </font>
  </p>
  <ul>
    <li>
      <p
        align="left"
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0.04in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
          <b>Lega Pauper Italia (LPI)</b>: l'ente che scrive e applica le seguenti regole
          nell'organizzazione. LPI è rappresentata dal Consiglio Direttivo,
          composto dai da membri in numero dispari.
        </font>
      </p>
    </li>
    <li>
      <p
        align="left"
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0.04in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
          <b>Lega Affiliata</b>: un gruppo di giocatori che organizza eventi pauper nella propria area di influenza, rispettando le seguenti regole. Una Lega affiliata è rappresentata da un Referente di Lega, da due Vice e dallo Staff di Lega.
        </font>
      </p>
    </li>
    <li>
      <p
        align="left"
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0.04in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
          <b>Stagione</b>: un periodo durante il quale si svolgono le tappe di lega.
        </font>
      </p>
    </li>
    <li>
      <p
        align="left"
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0.04in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
          <b>Tappa di Lega</b>: un torneo Pauper, parte di una serie di tornei che concorrono in
          un’unica classifica, organizzato da una lega affiliata.
        </font>
      </p>
    </li>
    <li>
      <p
        align="left"
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0.04in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
          <b>Paupergeddon ©</b>: tre eventi open Pauper all'anno organizzati da LPI e da altri
          partner scelti allo scopo. I Paupergeddon sono gli eventi pauper
          più importanti dell'anno per la LPI ed è un marchio registrato da
          LPI.
        </font>
      </p>
    </li>
    <li>
      <p
        align="left"
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0.04in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
          <b>International Pauper Tour (IPT)</b>: un evento open pauper organizzato dalla LPI, dalle Leghe
          Affiliate e dai negozi di giochi locali.
        </font>
      </p>
    </li>
    <li>
      <p
        align="left"
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0.04in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
          <b>Pauper Trio Event (PTE)</b>: un evento open pauper a squadre organizzato da LPI, Leghe
          affiliate e negozi di giochi locali.
        </font>
      </p>
    </li>
    <li>
      <p
        align="left"
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0.04in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
          <b>Top Pauper Player (TPP)</b>: è un evento gratuito a inviti per eleggere il miglior giocatore
          Pauper dell'anno.
        </font>
      </p>
    </li>
    <li>
      <p
        align="left"
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0.04in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
          <b>Colosseum Team Trios (CTT)</b>: è un evento Pauper open a squadre per eleggere la migliore
          squadra dell'anno.
        </font>
      </p>
    </li>
    <li>
      <p
        align="left"
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0.04in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
          <b>Pauper League World Cup (WCUP)</b>: è un torneo per eleggere la migliore squadra della lega
          affiliata.
        </font>
      </p>
    </li>
    <li>
      <p
        align="left"
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0.04in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
          <b>Bye</b>: è il premio che LPI mette in palio, sotto determinate condizioni, per
          ogni lega ad ogni season competitiva, che garantisce la vittoria
          automatica al primo turno del Paupergeddon di riferimento.
        </font>
      </p>
    </li>
  </ul>
  <h2
    className="western"
    style={{
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      pageBreakBefore: "always"
    }}
  >
    <a name="_Toc171978576" />
      <font size={4} style={{ fontSize: "14pt" }}>
        1.2. ANNO LPI E CALENDARIO (LPI YEAR)
      </font>
  </h2>
  <p style={{  marginBottom: "0.04in" }}>
    <font size={2} style={{ fontSize: "10pt" }}>
      LPI organizza i propri eventi basandosi sull’<b>Anno LPI</b> che inizia dopo il Paupergeddon Spring Edition e si conclude con il
      Paupergeddon Spring Edition successivo, compreso.
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font size={2} style={{ fontSize: "10pt" }}>
      L’anno LPI si compone di tre <b>Seasons</b>, che terminano con lo specifico Paupergeddon di riferimento. Le tappe di lega e le rispettive finali, se previste, devono concludersi entro:
    </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
            <b>Autumn Season:</b> 10 Novembre;
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginTop: "0in",
          marginBottom: "0in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
            <b>Winter Season:</b>23 Febbraio;
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginTop: "0in",
          marginBottom: "0in"
        }}
      >
        <font size={2} style={{ fontSize: "10pt" }}>
            <b>Spring Season:</b> 01 Giugno.
        </font>
      </p>
    </li>
  </ul>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978577" />
      <font size={4} style={{ fontSize: "14pt" }}>
        1.3. RAPPORTI CON L'ESTERNO (LPI AND OTHER ENTITIES)
      </font>
  </h2>
  <p style={{ orphans: 2, widows: 2 }}>
    <font size={2} style={{ fontSize: "10pt" }}>
      LPI si riserva di stipulare accordi di collaborazione con
      enti terzi, su base occasionale o in modo continuativo,
      contrattando la somma delle donazioni per finanziare gli
      eventi organizzati da LPI.
    </font>
  </p>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978578" />
      <font size={4} style={{ fontSize: "14pt" }}>
        1.4. RISORSE FINANZIARIE (FINANCIAL RESOURCES)
      </font>
  </h2>
  <p style={{  marginBottom: "0.04in" }}>
      <font size={2} style={{ fontSize: "10pt" }}>
        Ogni Lega per essere affiliata LPI <b>entro il 15 luglio</b> dell’anno di riferimento dovrà contribuire alle spese di gestione nella
        misura di <b>€ 30,00</b> in favore di LPI, nello specifico al <b>referente contabile LPI</b> a mezzo paypal (amici e parenti) come indicato nella sezione contatti.
      </font>
  </p>
  <p>
    <font size={2} style={{ fontSize: "10pt" }}>
      Tutte le quote raccolte verranno usate per finanziare:
    </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              i premi del circuito LPI
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              le spese connesse alla gestione del sito e della relativa versione
              mobile
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              spese di autopromozione di LPI
            </font>
      </p>
    </li>
  </ul>
  <p style={{  marginBottom: "0.04in" }}>
      <font size={2} style={{ fontSize: "10pt" }}>
        Il rendiconto annuale delle spese è disponibile su richiesta.
      </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
      <font size={2} style={{ fontSize: "10pt" }}>
        Nel caso in cui una nuova Lega venisse affiliata oltre la data indicata ed
        entro la fine della Winter Season, contribuirà anch’essa in egual
        misura, in caso contrario la quota sarà pari al 50% dell’importo sopra
        definito. Tale quota verrà accantonata e utilizzata l’anno successivo.
      </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
      <font size={2} style={{ fontSize: "10pt" }}>
        L'attività del Direttivo e dei Referenti di lega è totalmente gratuita e
        su base volontaria, nessuna eccezione ammessa.
      </font>
  </p>
  <br></br>
  <h1
    className="western"
    style={{ marginTop: "0in", pageBreakBefore: "always" }}
  >
    <a name="_Toc171978579" />
      <font size={5} style={{ fontSize: "18pt" }}>
        2 – Direttivo LPI (LPI Executive Board)
      </font>
  </h1>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978580" />
      <font size={4} style={{ fontSize: "14pt" }}>
        2.1. NOMINA (ELECTION)
      </font>
  </h2>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      LPI è coordinata dal <b>Direttivo</b>, che ha potere decisionale sulle scelte organizzative mediante l’esercizio del voto.
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      Il Direttivo è composto da membri di LPI, <b>in numero dispari</b>, con diritto di voto uno pro capite e può eleggere per votazione membri onorari che non hanno diritto di
      voto.
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      I membri del Direttivo possono essere sostituiti, aggiunti, rimossi,
      mediante votazione interna con maggioranza dei 2/3 del Direttivo
      stesso, mantenendo il numero dispari dei membri aventi diritto di
      voto.
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <b>2.1.1. RUOLI DEL DIRETTIVO (ROLES)</b>
  </p>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      Un membro del direttivo è un punto di riferimento, persona da
      contattare o gestisce uno dei seguenti aspetti:{" "}
    </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Paupergeddon Winter </b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Paupergeddon Spring </b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Paupergeddon Autumn </b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Paupergeddon &amp; LPI Brand Identity </b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Paupergeddon &amp; LPI Social Media Manager</b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>IPT/PTE Scheduling &amp; Calendar</b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Nord-Ovest NW AREA (Valle d’Aosta, Piemonte, Lombardia)</b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>
                Nord-Est NE AREA (Trentino Alto-Adige, Veneto, Friuli
                Venezia-Giulia)
              </b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Centro-Ovest CW AREA (Toscana, Liguria, Sardegna)</b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Centro-Est CE AREA (Emilia-Romagna, Marche Nord)</b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>
                Centro-Sud CS AREA (Lazio, Campania, Molise, Basilicata,
                Marche-Sud, Puglia, Calabria, Sicilia, Abruzzo)
              </b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Foreign Leagues</b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Treasurer</b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Watchlist</b>
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>LPI Ranking </b>
            </font>
      </p>
    </li>
  </ul>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
        <font size={2} style={{ fontSize: "10pt" }}>
          I membri del direttivo possono ricoprire più ruoli contemporaneamente.
        </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
        <font size={2} style={{ fontSize: "10pt" }}>
          L’assegnazione e la revoca dei ruoli è soggetta a votazione del
          Direttivo per maggioranza.{" "}
        </font>
  </p>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
        <font size={2} style={{ fontSize: "10pt" }}>
          È severamente vietato gestire competenze di un altro referente senza
          l’espresso assenso dello stesso
        </font>
  </p>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978581" />
    <a name="_heading=h.2s8eyo11" />
        <font size={4} style={{ fontSize: "14pt" }}>
          2.2. COORDINAMENTO LPI (LPI VOTING PROCESS)
        </font>
  </h2>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
        <font size={2} style={{ fontSize: "10pt" }}>
          Il Direttivo mediante votazione per maggioranza decide i seguenti
          aspetti:
        </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              assegnazione dei ruoli ai membri del Direttivo;
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              scelta del TO del Paupergeddon;
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              ammissione nuova lega affiliata;
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              modifiche al presente regolamento;
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              impiego delle risorse finanziarie;
            </font>
      </p>
    </li>
    <li>
      <p
        style={{
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
            <font size={2} style={{ fontSize: "10pt" }}>
              provvedimenti disciplinari;{" "}
            </font>
      </p>
    </li>
  </ul>
  <p
    align="left"
    style={{
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
      <font size={2} style={{ fontSize: "10pt" }}>
        qualsiasi decisione che non sia responsabilità di uno dei ruoli definiti
        al parametro precedente
      </font>
  </p>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978582" />
        <font size={4} style={{ fontSize: "14pt" }}>
          2.3. PROVVEDIMENTI DISCIPLINARI (DISCIPLINARY ACTIONS)
        </font>
  </h2>
  <p
    style={{
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      Il comportamento di ogni membro della comunità di LPI, sia egli membro del Direttivo, Referente di Lega o semplicemente frequentatore di una Lega Affiliata, può essere oggetto di valutazione da parte del Direttivo, che investigherà in caso di trasgressioni o segnalazioni per le opportune verifiche, ricorrendo se necessario a un provvedimento disciplinare. I possibili provvedimenti disciplinari sono:
    </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Richiamo scritto;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Sospensione temporanea dagli eventi LPI;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Espulsione permanente dagli eventi LPI.
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      <b>Il richiamo scritto</b> verrà applicato al componente che turbi l'attività ludica e che crei malcontento, senza però impedire o pregiudicare gravemente la realizzazione dei fini aggregativi;
    </font>
  </p>
  <p
    style={{
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      <b>La sospensione temporanea</b> verrà applicata al componente il cui comportamento accertato abbia
      turbato l'attività ludica e creato malcontento, impedendo o
      pregiudicando la realizzazione dei fini aggregativi;
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginLeft: "0.01in",
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      <b>L'espulsione permanente</b> di un componente verrà applicata quando:
    </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              si accerti che il soggetto con il proprio comportamento pregiudichi
              gravemente l'attività aggregativa o l'integrità morale di LPI;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              qualora compia atti anche non diretti contro LPI che contrastino o
              turbino gravemente l'attività aggregativa.
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font color="#000000">
      <font face="Tahoma, sans-serif">
        <font size={2} style={{ fontSize: "10pt" }}>
          Il provvedimento disciplinare sarà attuativo dal momento in cui è
          recapitato al destinatario in forma scritta.
        </font>
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <br />
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <br />
  </p>
  <h1
    className="western"
    style={{ marginTop: "0in", pageBreakBefore: "always" }}
  >
    <a name="_Toc171978583" />
    <font size={5} style={{ fontSize: "18pt" }}>
      3 – Leghe Affiliate LPI (LPI Leagues)
    </font>
  </h1>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978584" />
    <font size={4} style={{ fontSize: "14pt" }}>
      3.1. FONDARE UNA LEGA (START A LEAGUE)
    </font>
  </h2>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      Ogni giocatore ha la possibilità di fondare una propria <b>Lega</b>, scegliendo un nome che non sia già di un'altra Lega affiliata o
      confondibile con essa, e diventarne Referente.
    </font>
  </p>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
      <font size={2} style={{ fontSize: "10pt" }}>
        Il medesimo dovrà da sé informarsi sul contenuto di questo regolamento,
        proponendosi come Referente e attendere il riconoscimento da parte del
        Direttivo LPI.
      </font>
  </p>
  <h3 className="western">
    <a name="_Toc171978585" />
    <font face="Tahoma, sans-serif">3.1.1 Requisiti (Requirements)</font>
  </h3>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      Una Lega per far parte del “<b>circuito LPI</b>” deve:
    </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              rispettare il presente regolamento e le indicazioni del Direttivo;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              rispettare le regole del formato Pauper come indicato dai canali
              ufficiali Wizards of the Coast;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              avere un Referente di Lega riconosciuto dal Direttivo e non
              coesistere nel territorio di un'altra Lega già riconosciuta;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Creare almeno un account su un canale social (Facebook,
              Instragram, etc..) a nome: “Lega Pauper” + nome della propria Lega
              + eventuali altri nomi seguiti da “-” che pubblicizzi gli eventi
              della lega stessa.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              organizzare un minimo di 6 (sei) tappe in almeno una season
              competitiva conservando per un anno LPI i dati delle singole tappe
              (giocatori, punteggio, screen applicativo usato);{" "}
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              contribuire alle spese organizzative tramite la quota annuale di
              30.00€{" "}
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      Per poter rinnovare la propria presenza all’interno dell’organico LPI ogni Lega affiliata deve rispettare i sopracitati requisiti per OGNI
      anno competitivo.
    </font>
  </p>
  <h3 className="western">
    <a name="_Toc171978586" />
      <span lang="en-US">
        3.1.2 Referente e Staff di Lega (League Manager and their staff)
      </span>
  </h3>
  <p
    style={{
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      Il Referente di una Lega può essere <b>solo uno.</b> Una Lega può tuttavia avere più organizzatori nello staff a patto che
      comunque il Referente responsabile venga individuato e riconosciuto dal
      Direttivo.
    </font>
  </p>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      Ogni Referente di Lega può nominare fino ad un massimo di 2 (due) membri
      della propria Lega quali vice-referenti, che faranno le veci del
      referente in assenza di quest’ultimo. Per garantire un processo
      decisionale democratico, solo il Referente, o uno dei vice al suo posto,
      può partecipare alle scelte e votazioni riservate ai referenti
      all’interno di LPI.
    </font>
  </p>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978587" />
      <font size={4} style={{ fontSize: "14pt" }}>
        3.2 REGOLAMENTO INTERNO (LEAGUE RULEBOOK)
      </font>
  </h2>
  <p style={{  marginBottom: "0.04in" }}>
      <font size={2} style={{ fontSize: "10pt" }}>
        Ogni Referente di Lega, prima dell’inizio della lega, dovrà comunicare ai partecipanti <b>i criteri</b> con i quali verranno organizzate le tappe, le modalità di assegnazione
        dei punti della classifica lega e dei Bye.
      </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
      <font size={2} style={{ fontSize: "10pt" }}>
        Ogni Referente di Lega deve stilare il regolamento in modo che sia
        facilmente <b>fruibile e consultabile</b> da ogni partecipante. In caso una lega non abbia stilato un regolamento
        interno, la norma generale prevede:
      </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              il conteggio dei soli punti di svizzera conseguiti in tutte le
              tappe di lega: vittoria 3 punti, pareggio 1 punto e sconfitta 0
              punti;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              l’assegnazione dei Bye in un torneo ad eliminazione diretta
              dedicato alla Top8 della classifica di lega;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              in caso di pareggio, tutti i potenziali qualificati alla Top8
              parteciperanno invece ad un torneo dedicato alla Top8 allargata,
              con turni di svizzera e Top4.
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <h3 className="western">
    <a name="_Toc171978588" />
    <font face="Tahoma, sans-serif">3.2.1 Assegnare un Bye (Award a Bye) </font>
  </h3>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I <b>Bye</b> possono essere assegnati solo a coloro che hanno partecipato alla lega e
        non sarà possibile fare un evento speciale in cui metterli in palio gli
        stessi. I criteri di assegnazione del Bye devono basarsi sul merito,
        secondo una qualsiasi combinazione delle seguenti modalità:
      </font>
    </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Attribuzione per classifica generale
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Attribuzione per Top8 ad eliminazione diretta o doppia
              eliminazione, con qualifica tramite classifica generale.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Attribuzione per Top8/Top4 ad eliminazione diretta o doppia
              eliminazione, dopo opportuni turni di svizzera, con qualifica
              tramite classifica generale
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il giocatore primo classificato deve sempre giocare anche la fase ad
        eliminazione diretta. Il Bye di lega può “<b>scalare</b>”, ovvero essere attribuito ad un giocatore diverso dal vincitore solo
        nei seguenti casi:
      </font>
    </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Un giocatore risulti vincitore di due Bye per la stessa lega e la
              stessa stagione (es: in una lega che attribuisce due Bye, uno per
              classifica generale e uno per Top8, il giocatore primo in
              classifica vinca anche la fase di ad eliminazione diretta: in quel
              caso entrambi i finalisti saranno assegnatari di Bye)
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Il giocatore vincitore del Bye per classifica non partecipa al
              Paupergeddon: il Bye è riassegnato secondo Top8, al primo
              giocatore non assegnatario di Bye per la lega in analisi.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Il vincitore del Bye per Top8 non partecipa al Paupergeddon: il
              Bye è riassegnato secondo Top8, al primo giocatore non
              assegnatario di Bye per la lega in analisi.
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        In nessun caso un giocatore potrà essere assegnatario di un Bye se non
        qualificato nella Top8 del finale di Lega.
      </font>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Bye ottenuti dai giocatori da altri tornei come super IPT o altre finali
        di lega sono ininfluenti al fine di determinare la possibilità che il
        Bye possa o no scalare.
      </font>
    </font>
  </p>
  <h3 className="western">
    <a name="_Toc171978589" />
    <font face="Tahoma, sans-serif">3.2.2 Calendario (Calendar)</font>
  </h3>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Ogni Referente di Lega, entro il 15 Luglio, dovrà comunicare al
        Direttivo il calendario di massima degli eventi della propria Lega
        compresi gli eventi classificati come IPT. Non sarò possibile svolgere
        contemporaneamente due leghe per due season differenti.
      </font>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Sarà opportuno aspettare il benestare del Direttivo prima di organizzare
        e poi pubblicare gli eventi del Circuito LPI, eccezion fatta per le
        tappe di lega.
      </font>
    </font>
  </p>
  <h3 className="western">
    <a name="_Toc171978590" />
    <font face="Tahoma, sans-serif">
      3.2.3 Adesione ad una Lega (Attend a League)
    </font>
  </h3>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I giocatori possono partecipare a qualunque torneo e qualunque tappa di
        lega del circuito LPI. Vittore di Bye in palio presso leghe differenti
        nella stessa season non sono cumulabili, a meno di eccezioni approvate
        dal Direttivo.
      </font>
    </font>
  </p>
  <h3 className="western">
    <a name="_Toc171978591" />
    <font face="Tahoma, sans-serif">3.2.4 Formati (Formats)</font>
  </h3>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Tutte le <b>tappe e le finali di lega</b> devono essere organizzate nel formato Pauper Regular.
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        LPI approva e supporta l’organizzazione di eventi dei seguenti formati
        derivati, che però non possono avere alcuna valenza come tappe di lega:
      </font>
    </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Team Trios Unified Pauper. Tornei in cui i giocatori si presentano
              in squadre di 3 giocatori, secondo le regole del formato Team
              Trios Unified, utilizzando solo mazzi costruiti secondo le regole
              del formato Pauper, senza nessuna carta in comune ad eccetto delle
              terre base.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Pauper Draft Master. Tornei basati sul draft del Cubo Pauper Draft
              Master, secondo le regole indicate dalla pagina LPI dedicata, e la
              cui lista ufficiale è disponibile al link:
              <br />
              <a href="https://cubecobra.com/cube/list/pauper-draft-master">
                https://cubecobra.com/cube/list/pauper-draft-master
              </a>
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Pauper Unbanned. Tornei in cui i giocatori rispettano le regole
              del formato Pauper Pauper, ma senza l’obbligo di rispettare la
              banlist.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Pauper Commander. Tornei in cui i giocatori rispettano le regole
              del formato Pauper Commander, come indicato dalla pagina LPI
              dedicata.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Pauper 2HG. Tornei in cui i giocatori si presentano in coppia,
              secondo le regole del formato 2HG, utilizzando solo mazzi
              costruiti secondo le regole del formato Pauper.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Pauper Peasant. Tornei in cui i giocatori rispettano le regole del
              formato Pauper Peasant.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Mtg Online Pauper. Tornei Pauper effettuati sulla piattaforma
              ufficiale MTGO.
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <a name="_Toc171978592" />
    <br />
  </p>
  <h1
    className="western"
    align="left"
    style={{ marginTop: "0in", pageBreakBefore: "always" }}
  >
    <font face="Tahoma, sans-serif">
      <font size={5} style={{ fontSize: "18pt" }}>
        4 – Paupergeddon Events
      </font>
    </font>
  </h1>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978593" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        4.1 PAUPERGEDDON ©
      </font>
    </font>
  </h2>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      Il Paupergeddon, <b>marchio registrato ad uso esclusivo di LPI</b>, è un evento open che rappresenta il coronamento e traguardo di ogni
    Season, con lo scopo di creare un evento dove tutti i giocatori italiani
    ed internazionali possano trovarsi e condividere la passione per questo
    formato.
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I Paupergeddon sono organizzati al termine di ogni season unitamente ad
        un evento speciale, rispettando la seguente locazione geografica:
      </font>
    </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Autumn Edition</b>: si tiene in prossimità di Roma
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Winter Edition</b>: si tiene in prossimità di Milano
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>Spring Edition</b>: si tiene in prossimità di Pisa
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978594" />
    <font face="Tahoma, sans-serif">4.1.1 Organizzatori (Event Organizer)</font>
  </h3>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font color="#000000">
      <font face="Tahoma, sans-serif">
        <font size={2} style={{ fontSize: "10pt" }}>
          Gli organizzatori del torneo Paupergeddon, d'ora in poi “<b>TO</b>”, sono formati da un membro del Direttivo e da un membro del negozio,
          dell’associazione o dell’entità <b>eletta dal direttivo</b> per l’organizzazione del Paupergeddon stesso.
        </font>
      </font>
    </font>
  </p>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978595" />
    <font face="Tahoma, sans-serif">
      4.1.2 Modalità di accesso (Access fee)
    </font>
  </h3>
  <p
    style={{
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font size={2} style={{ fontSize: "10pt" }}>
      Il costo di ingresso viene deciso dal TO dell'evento, ed approvato dal
      Direttivo in seguito alla verifica di un documento contente la
      previsione di: costi, entrate e griglie premi main event e side event.
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font size={2} style={{ fontSize: "10pt" }}>
      In caso di scostamento da quanto preventivato, gli oneri saranno a
      carico esclusivo del TO.
    </font>
  </p>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978596" />
    <font face="Tahoma, sans-serif">
      4.1.3 Requisiti essenziali (Minimun requirements)
    </font>
  </h3>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Un evento per essere considerato un Paupergeddon deve rispettare i
        seguenti requisiti di qualità:
      </font>
    </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Fornire Judge proporzionati all'evento, sia per qualità che per
              quantità;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Avere la disponibilità per un locale accessibile e adeguato al nr.
              di giocatori previsti ad un minimo di 500 giocatori;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Essere pubblicizzato al meglio delle possibilità del TO
              dell'evento;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Fornire una copertura video totale dell'evento, comprensiva di
              commentario;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Non essere conteggiato come tappa di Lega;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Premiare tassativamente almeno la top 64 a prescindere dal numero
              dei partecipanti.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Fornire una griglia premi adeguata al costo d’ingresso
              dell’evento.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Garantire una ottimale vivibilità dell’evento.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Fornire le informazioni a tutte le community LPI in maniera chiara
              ed esaustiva.
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <h3 className="western">
    <a name="_Toc171978597" />
    <font face="Tahoma, sans-serif">4.1.4 Montepremi (Prize pool)</font>
  </h3>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I premi sono decisi dal TO, in relazione al numero di partecipanti
        all'evento, predisponendo sempre una griglia <b>garantita</b> e provvedendo alla realizzazione/integrazione, in misura concordata con
        il Direttivo, dei premi per gli eventi sub 4.2, 4.3 e 4.4.
      </font>
    </font>
  </p>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978598" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        <span lang="en-GB">4.2 PAUPER LEAGUE WORLD CUP (WCUP)</span>
      </font>
    </font>
  </h2>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Volendo rendere più accattivante il mondo Pauper e dare al formato una
        dimensione internazionale forte, è stata istituita la MTG Pauper League
        World Cup, ovvero una competizione a TEAM per aggiudicarsi la coppa del
        mondo, riservata alle Leghe Pauper affiliate a LPI. La Pauper League
        World Cup mira a eleggere la lega più forte dell’anno, e si disputa in
        contemporanea al <b>Paupergeddon Winter Edition</b>
      </font>
    </font>
  </p>
  <h3 className="western">
    <a name="_Toc171978599" />
    <font face="Tahoma, sans-serif">
      4.2.1 Modalità di accesso (means of access)
    </font>
  </h3>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Possono partecipare tutte le Leghe Pauper affiliate, nominando <b>un solo</b> Team (Squadra di Lega/Team di Lega) composto da un minimo di 2 fino a un
        massimo di 5 giocatori: 3 titolari e 2 riserve.
      </font>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I nominativi dei giocatori devono essere comunicati dal Referente di
        Lega almeno <b>entro e non oltre le 23:59 dell’ultimo giorno della Winter Season</b>, pena la mancata qualifica della lega dalla Pauper League World Cup,
        all'indirizzo e-mail
      </font>
    </font>
    <a href="mailto:lpauperitalia@gmail.com">
      <font color="#1155cc">
        <font face="Tahoma, sans-serif">
          <font size={2} style={{ fontSize: "10pt" }}>
            <u>lpauperitalia@gmail.com</u>
          </font>
        </font>
      </font>
    </a>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        (o altro metodo tempestivamente comunicato dal TO del Paupergeddon o dal
        Direttivo).{" "}
      </font>
    </font>
  </p>
  <h3 className="western">
    <a name="_Toc171978600" />
    <font face="Tahoma, sans-serif">4.2.2 World Cup Teams</font>
  </h3>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Ogni Lega può decidere autonomamente le modalità con le quali nominare i
        membri del proprio Team,<b>unica condizione: abbiano partecipato almeno ad una tappa di Lega di
        riferimento del Team.</b>
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I Team devono avere minimo 2 giocatori e le Leghe possono indicare,
        oltre ai 3 giocatori titolari, anche due riserve che subentrano nel caso
        i giocatori titolari non si presentino al Paupergeddon.
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Le riserve devono subentrare al posto dei titolari prima dell’inizio del
        torneo stesso.
      </font>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I giocatori facenti parte di un Team di Lega <b>devono essere chiaramente identificabili nel torneo</b> e si devono rendere disponibili a inviare le risposte ad un’intervista
        prima, dopo o durante il Paupergeddon.
      </font>
    </font>
  </p>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978601" />
    <font face="Tahoma, sans-serif">
      4.2.3 Modalità di calcolo del punteggio (Ranking)
    </font>
  </h3>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I Team di Lega partecipano a una classifica a parte dove ogni Team ha
        tanti punti quant'è la somma dei punti dei suoi membri. <b>Il Team con più punti alla fine della svizzera</b> del Paupergeddon vince la “COPPA DEL MONDO” e i premi in palio, verrà
        successivamente inserito nell'Albo d'Onore dei vincitori del MTG Pauper League World Cup. In caso di parità si sottrae il risultato più basso dei 3 giocatori del Team e si confronta nuovamente. In caso di ulteriore parità, si guarda la posizione in classifica di svizzera del migliore
        giocatore dei Team a pari merito.
      </font>
    </font>
  </p>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978602" />
    <font face="Tahoma, sans-serif">4.2.4 Montepremi (Prize pool)</font>
  </h3>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I premi vengono stanziati nella <b>misura del 10% </b> di quanto raccolto dalle Leghe affiliate ad inizio anno. Il montepremi
        verrà utilizzato per premiare solo il team classificatosi primo.
      </font>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        La lega vincitrice ottiene <b>un Bye aggiuntivo</b> per la season successiva.
      </font>
    </font>
  </p>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978603" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        4.3 TOP PAUPER PLAYER (TPP)
      </font>
    </font>
  </h2>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il Top Pauper Player (TPP) <b>è un evento gratuito e ad invito</b> (aka invitational) che viene disputato <b>il giorno prima del Paupergeddon Spring Edition. </b>
      </font>
    </font>
  </p>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Esso, come suggerisce il nome, determina il più forte fra i giocatori
        che hanno ottenuto i migliori risultati durante l'anno.{" "}
      </font>
    </font>
  </p>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978604" />
    <font face="Tahoma, sans-serif">
      4.3.1 Modalità di invito (Invitation ticket)
    </font>
  </h3>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Sono qualificati al TPP tutti i giocatori <b>con almeno 300 LPI points alla fine della Spring Season</b>, contando gli eventi LPI <b>a partire dall’ultimo TPP compreso.</b>
      </font>
    </font>
  </p>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        L'accesso al torneo non può essere in alcun modo ceduto a terzi.
      </font>
    </font>
  </p>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978605" />
    <font face="Tahoma, sans-serif">4.3.2 Montepremi (Prize pool)</font>
  </h3>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font color="#000000">
      <font face="Tahoma, sans-serif">
        <font size={2} style={{ fontSize: "10pt" }}>
          I premi vengono stanziati nella <b>misura del 55%</b> di quanto raccolto dalle Leghe affiliate ad inizio anno. Il montepremi
          verrà utilizzato per premiare la <b>Top4</b> dell’evento.
        </font>
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        In aggiunta al montepremi previsto, i finalisti del TPP ottengono <b>un Bye</b> per il Paupergeddon Spring Edition del giorno successivo. Il <b>Bye del solo finalista è cumulabile</b> con altri Bye ottenuti nel corso della stagione.
      </font>
    </font>
  </p>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978606" />
    <font face="Tahoma, sans-serif">4.3.3 LPI Points</font>
  </h3>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il progetto <b>LPI Points mira a rendere più avvincente l’esperienza competitiva</b> all’interno del circuito, promuovere la partecipazione agli eventi,
        conservare in un unico luogo i dati dei tornei LPI. 
      </font>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
      Ogni torneo è un evento indipendente, che fornisce punti a chi si piazza
        in top secondo la seguente formula e come mostrato nella tabella di
        esempio:
      </font>
    </font>
  </p>
  <p
    align="center"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        <span lang="en-US">
          <b>
            LPI POINTS: 10 * SWISS ROUND * POSITION MULTIPLIER * TOURNAMENT
            MULTIPLIER
          </b>
        </span>
      </font>
    </font>
  </p>
  <center>
    <table width={529} cellPadding={7} cellSpacing={0}>
      <colgroup>
        <col width={212} />
        <col width={137} />
        <col width={136} />
      </colgroup>
      <tbody>
        <tr>
          <td
            width={212}
            height={8}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  POSITION
                </font>
              </font>
            </p>
          </td>
          <td
            width={137}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  MULTIPLIER NO SPLIT
                </font>
              </font>
            </p>
          </td>
          <td
            width={136}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  MULTIPLIER SPLIT
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={212}
            height={9}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Top1
                </font>
              </font>
            </p>
          </td>
          <td
            width={137}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  2.50
                </font>
              </font>
            </p>
          </td>
          <td
            width={136}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  -
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={212}
            height={9}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Top2
                </font>
              </font>
            </p>
          </td>
          <td
            width={137}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  2.00
                </font>
              </font>
            </p>
          </td>
          <td
            width={136}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  2.2500
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={212}
            height={9}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Top4
                </font>
              </font>
            </p>
          </td>
          <td
            width={137}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  1.50
                </font>
              </font>
            </p>
          </td>
          <td
            width={136}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  1.8750
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={212}
            height={9}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Top8
                </font>
              </font>
            </p>
          </td>
          <td
            width={137}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  1.00
                </font>
              </font>
            </p>
          </td>
          <td
            width={136}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  1.4375
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={212}
            height={9}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Top16 (129+ Players)
                </font>
              </font>
            </p>
          </td>
          <td
            width={137}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  0.40
                </font>
              </font>
            </p>
          </td>
          <td
            width={136}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  -
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={212}
            height={8}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Top32 (410+ Players)
                </font>
              </font>
            </p>
          </td>
          <td
            width={137}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  0.20
                </font>
              </font>
            </p>
          </td>
          <td
            width={136}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  -
                </font>
              </font>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </center>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Per le Finali di Lega, il moltiplicatore di Swiss Round è sempre da
        considerare pari a 1 e sono da tenere in considerazione solo gli altri
        moltiplicatori.
      </font>
    </font>
  </p>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Solo in caso di split, ovvero fase ad eliminazione diretta NON giocata,
        a prescindere e indipendentemente dallo split o distribuzione della
        griglia premi, è applicata equa spartizione degli LPI residui fra i
        giocatori che attuano lo split.
      </font>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Perché un torneo sia inserito nel database, deve essere un evento
        facente parte del circuito LPI fra quelli indicati nella seguente
        tabella:
      </font>
    </font>
  </p>
  <center>
    <table width="74%" cellPadding={7} cellSpacing={0}>
      <colgroup>
        <col width="183*" />
        <col width="73*" />
      </colgroup>
      <tbody>
        <tr>
          <td
            width="71%"
            height={4}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  <span lang="en-US">TOURNAMENT</span>
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  <span lang="en-US">MULTIPLIER</span>
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr valign="top">
          <td
            width="71%"
            height={5}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  0 Bye League Final
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  2.10
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr valign="top">
          <td
            width="71%"
            height={5}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  1 Bye League Final
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  3.75
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr valign="top">
          <td
            width="71%"
            height={5}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  2 Bye League Final
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  4.50
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr valign="top">
          <td
            width="71%"
            height={5}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  <span lang="en-US">
                    3+ Bye League Final (Special Status Only)
                  </span>
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  5.25
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr valign="top">
          <td
            width="71%"
            height={5}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  <span lang="en-GB">
                    Pauper Rebound (Paupergeddon Side Event)
                  </span>
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  1.00
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr valign="top">
          <td
            width="71%"
            height={5}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  <span lang="en-US">
                    Internation Pauper Tour: IPT (6+ Rounds, 33+ Player)
                  </span>
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  1.25
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr valign="top">
          <td
            width="71%"
            height={5}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  <span lang="en-US">
                    Internation Pauper Tour: IPT (Super, 100+ Player)
                  </span>
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  1.50
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr valign="top">
          <td
            width="71%"
            height={5}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  <span lang="en-US">Last Chance Trial (</span>
                </font>
              </font>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  <span lang="en-GB">Paupergeddon Side Event)</span>
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  1.50
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr valign="top">
          <td
            width="71%"
            height={5}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Top Pauper Player: TPP
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  2.00
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr valign="top">
          <td
            width="71%"
            height={5}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Paupergeddon ©
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  2.00
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr valign="top">
          <td
            width="71%"
            height={5}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  <span lang="en-US">
                    Pauper Trio Event: PTE (5+ Rounds, 17+ teams)
                  </span>
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  0.75
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr valign="top">
          <td
            width="71%"
            height={4}
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  Colosseum Team Trio: CTT
                </font>
              </font>
            </p>
          </td>
          <td
            width="29%"
            style={{ border: "1.00pt solid #000000", padding: "0.07in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Tahoma, sans-serif">
                <font size={2} style={{ fontSize: "10pt" }}>
                  1.25
                </font>
              </font>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </center>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Per i Team Trio Events, sanno attribuiti punti alla Top4 per tornei con
        5+ turni.{" "}
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Chi ottenga un risultato con una lista illegale non riceverà alcun punto
        da quel risultato.
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Giocatori bannati da LPI e/o da Wizards of the Coast sono possono
        accumulare LPI points durante il periodo del ban, e la loro eventuale
        posizione nella classifica di un evento giocato in quel periodo rimane
        vacante.
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        LPI si riserva di attribuire LPI Points ad altri eventi ufficiale
        co-organizzati, dandone preventiva ed esplicita comunicazione.
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I punti accumulati da ogni giocatore sono pubblici e visualizzabili in
        un database.
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Ogni giocatore ha diritto a fare richiesta di comparire in modo anonimo
        nella classifica facendone richiesta a LPI: la lista degli invitati al
        TPP è sempre pubblica.
      </font>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Ogni giocatore può rinunciare ad apparire, anche in forma anonima, nella
        classifica, ed accumulare di conseguenza LPI points. All'inizio
        dell'anno LPI è possibile revocare lo status di oblio previa
        comunicazione al referente del Ranking: tutti i punti accumulati fino a
        diversa comunicazione sono persi.{" "}
      </font>
    </font>
  </p>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        <span lang="en-US"> </span>
      </font>
    </font>
  </p>
  <center>
    <table width={715} cellPadding={7} cellSpacing={0}>
      <colgroup>
        <col width={48} />
        <col width={45} />
        <col width={45} />
        <col width={45} />
        <col width={45} />
        <col width={45} />
        <col width={45} />
        <col width={45} />
        <col width={45} />
        <col width={45} />
        <col width={45} />
        <col width={44} />
      </colgroup>
      <tbody>
        <tr>
          <td
            width={48}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>League 0 bye</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>League 1 bye</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>League 2 bye</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <span lang="en-US">
                          <b>
                            League 3+ bye
                            <br />
                          </b>
                        </span>
                      </font>
                    </font>
                  </font>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={1} style={{ fontSize: "6pt" }}>
                        <span lang="en-US">
                          <b>Special status only</b>
                        </span>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>
                          IPT
                          <br />
                          6R
                        </b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>
                          IPT
                          <br />
                          7R
                        </b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>SIPT 8R</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={1} style={{ fontSize: "7pt" }}>
                        <b>
                          PAUPER
                          <br />
                          GEDDON
                        </b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>
                          PTE
                          <br />
                        </b>
                      </font>
                    </font>
                  </font>
                  <font face="Tahoma, sans-serif">
                    <font size={2} style={{ fontSize: "9pt" }}>
                      <span lang="en-US">
                        <b>5R</b>
                      </span>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>CTT</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={44}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p
              align="center"
              style={{ orphans: 2, widows: 2, marginBottom: "0.04in" }}
            >
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>TPP</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p
              align="center"
              style={{ orphans: 2, widows: 2, marginBottom: "0.04in" }}
            >
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "9pt" }}>
                        <b>6R</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
            <p style={{ orphans: 2, widows: 2 }}>
              <font color="#000000"> </font>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={1} style={{ fontSize: "6pt" }}>
                        <b>Minimun</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={48}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        <b>Winner</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      50.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      93.8
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      112.5
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      131.3
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      187.5
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      218.8
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#ff0000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <b>300.0</b>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#ff0000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <b>650.0</b>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      93.4
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      156.3
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={44}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#ff0000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <b>300.0</b>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={48}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font face="Tahoma, sans-serif">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <span lang="en-US">
                        <b>Finalist</b>
                      </span>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      40.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      75.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      90.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      105.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      150.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      175.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      240.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#ff0000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <b>520.0</b>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      75.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      125.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={44}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      240.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={48}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        <b>Top4</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      30.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      56.3
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      67.5
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      78.8
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      112.5
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      131.3
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      180.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#ff0000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <b>390.0</b>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      56.3
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      93.8
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={44}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      180.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={48}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        <b>Top8</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      20.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      37.5
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      45.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      52.5
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      75.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      87.5
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      120.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      260.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={44}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      120.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={48}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        <b>Split</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      28.8
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      53.9
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      64.7
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      75.6
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      107.8
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      125.8
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      172.5
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#ff0000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      <b>373.8</b>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={44}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      172.5
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={48}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        <b>Top16</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      48.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      104.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={44}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
        </tr>
        <tr>
          <td
            width={48}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font face="Tahoma, sans-serif">
                      <font size={2} style={{ fontSize: "10pt" }}>
                        <b>Top32</b>
                      </font>
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p align="center" style={{ orphans: 2, widows: 2 }}>
              <font face="Arial, sans-serif">
                <font size={4} style={{ fontSize: "14pt" }}>
                  <font color="#000000">
                    <font size={2} style={{ fontSize: "10pt" }}>
                      52.0
                    </font>
                  </font>
                </font>
              </font>
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={45}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
          <td
            width={44}
            style={{ border: "1px solid #000000", padding: "0in 0.08in" }}
          >
            <p lang="en-US" align="center" style={{ orphans: 2, widows: 2 }}>
              <br />
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </center>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978607" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        <span lang="en-GB">4.4 COLOSSEUM TEAM TRIOS (CTT)</span>
      </font>
    </font>
  </h2>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il Colosseum Team Trios (CTT) è un evento open che viene disputato il
        giorno prima del <b>Paupergeddon Autumn Edition</b>. 
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il formato dell’evento è Team Constructed Unified – Pauper.
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        L’evento è organizzato da Lega Pauper Roma (LPR) in collaborazione col
        TO del Paupergeddon Autumn Edition.
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il CTT, come suggerisce il nome, mira a eleggere il team più forte
        dell'anno.
      </font>
    </font>
  </p>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978608" />
    <font face="Tahoma, sans-serif">4.4.1 Regola d’oro (Golden rule)</font>
  </h3>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il formato scelto per il CTT è quello del Team Constructed Unified: 3
        player con 3 mazzi Pauper che non dovranno <b>avere alcuna carta in comune fatta eccezione per le terre base.</b>
      </font>
    </font>
  </p>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978609" />
    <font face="Tahoma, sans-serif">4.4.2 Montepremi (Prize pool)</font>
  </h3>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il montepremi del CTT è creato utilizzando tutte le quote di iscrizione
        dei vari team. All’organizzazione del CTT è assegnato <b>un bonus nella misura del 10%</b> di quanto raccolto dalle Leghe affiliate ad inizio anno, da usare <b>per premiare la squadra prima classificata.</b>
      </font>
    </font>
  </p>
  <p
    lang="en-US"
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <br />
  </p>
  <h1
    className="western"
    align="left"
    style={{ marginTop: "0in", pageBreakBefore: "always" }}
  >
    <a name="_Toc171978610" />
    <font face="Tahoma, sans-serif">
      <font size={5} style={{ fontSize: "18pt" }}>
        <span lang="en-US">5 – Byes &amp; Road to Paupergeddon!</span>
      </font>
    </font>
  </h1>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978611" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        <span lang="en-US">5.1 FASCE ATTRIBUZIONE (BYE THRESHOLD)</span>
      </font>
    </font>
  </h2>
  <p
    style={{ marginBottom: "0.04in" }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Tutte le Leghe che vogliono rientrare nelle fasce per i Bye devono avere
        conseguito almeno 6 (sei) tappe. Ai fini dell’assegnazione dei Bye, <b>
          il numero medio di giocatori è da calcolare sulle 6 (sei) tappe con
          maggior numero di giocatori della stagione in corso
        </b>. La media deve rientrare nelle seguenti categorie, o fasce:
      </font>
    </font>
  </p>
  <ul>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>1 Bye: 16.0</b>
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <b>2 Bye: 26.0</b>
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        La media effettiva è sempre arrotondata per difetto alla prima cifra
        decimale.
      </font>
    </font>
  </p>
  <h2 className="western">
    <a name="_Toc171978612" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        5.2 TEMPISTICHE (DEADLINE FOR SUBMISSION)
      </font>
    </font>
  </h2>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I Referenti di Lega devono inviare i dati necessari per confermare
        l'avvenuto torneo. I dati devono essere inviati al membro del Direttivo
        incaricato TO del Paupergeddon al termine della lega o comunque non
        oltre il termine della season di riferimento.{" "}
      </font>
    </font>
  </p>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Ogni Lega è obbligata a tenere traccia della classifica della Lega nei
        modi che ritiene più opportuni, in modo che sia sempre consultabile su
        richiesta.{" "}
      </font>
    </font>
  </p>
  <h2 className="western">
    <a name="_Toc171978613" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        <span lang="en-US">5.3 SEASON ACCORPATE (SKIP A SEASON)</span>
      </font>
    </font>
  </h2>
  <p align="left">
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Le Leghe <b>
          possono richiedere di accorpare due o più season a un solo
          Paupergeddon di riferimento,</b> perché possano saltare quello di minor interesse per la propria Lega
        (perché, ad esempio, geograficamente troppo distante). In tal caso,
        verranno conteggiate come date di un’unica season con un solo
        Paupergeddon di riferimento. In tal caso, per il conteggio del minimo
        delle tappe, si considera 6 (sei) tappe, <b>più 1 (una) tappa in aggiunta per ogni season accorpata,</b> mantenendo invariate le fasce per l’assegnazione dei Bye.{" "}
        
      </font>
    </font>
  </p>
  <h2 className="western">
    <a name="_Toc171978614" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        5.4 TRIAL PAUPERGEDDON
      </font>
    </font>
  </h2>
  <p
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginBottom: "0.04in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Ogni TO del Paupergeddon ha diritto di assegnare <b>Bye supplementari</b> non cumulabili, valido solo per il Paupergeddon che organizzerà, 
        da mettere in premio ad un torneo <b>Trial Open</b>. La modalità di assegnazione deve essere approvata dal direttivo LPI.
      </font>
    </font>
  </p>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978615" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        5.5 LEGHE ESTERE (FOREIGN LEAGUES)
      </font>
    </font>
  </h2>
  <p align="left">
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Anche le Leghe Pauper estere possono aderire al regolamento e ricevere i
        benefici del circuito italiano, se ne rispettano i requisiti.
      </font>
    </font>
  </p>
  <h2
    className="western"
  >
    <a name="_Toc171978616" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        <span lang="en-US">5.6 STATUTI SPECIALI (SPECIAL STATUS LEAGUES)</span>
      </font>
    </font>
  </h2>
  <p style={{  orphans: 2, widows: 2, marginBottom: "0in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il Direttivo ha approvato i regolamenti interni delle seguenti leghe a
        statuto speciale.
      </font>
    </font>
  </p>
  <ul>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font color="#000000">
            <font face="Tahoma, sans-serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                <b>Lega Pauper Roma</b>
              </font>
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font color="#000000">
            <font face="Tahoma, sans-serif">
              <font size={2} style={{ fontSize: "10pt" }}>
                <b>Lega Pauper Online: Pauperwave </b>
              </font>
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <h2
    className="western"
  >
    <a name="_Toc171978617" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        5.7 EVENTI SPECIALI (SPECIAL EVENTS)
      </font>
    </font>
  </h2>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il Direttivo si riserva di attribuire a tornei facente parte del
        circuito LPI, dandone preventiva comunicazione: ingressi gratuiti, Bye
        addizionali e/o premi, sulla base di principi meritocratici.
      </font>
    </font>
  </p>
  <h2
    className="western"
    style={{ orphans: 2, widows: 2, marginBottom: "0.08in" }}
  >
    <a name="_Toc171978618" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        5.8 PAUPERGEDDON BREAK
      </font>
    </font>
  </h2>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Durante il mese precedente al Paupergeddon non è possibile organizzare
        eventi LPI (IPT, PTE, Etc…). Sarà possibile per le leghe organizzare
        tappe valide per la stagione successiva a quella in corso, ad esempio
        Tappe Road to Paupergeddon Autumn – Roma durante la settimana precedente
        al Paupergeddon Spring – Pisa, ad esclusione dei giorni del Paupergeddon
        e dei side eventi LPI come Top Pauper Player e Colosseum Team Trios.
      </font>
    </font>
  </p>
  <p
    lang="en-US"
    align="left"
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <br />
  </p>
  <h1
    className="western"
    align="left"
    style={{ marginTop: "0in", pageBreakBefore: "always" }}
  >
    <a name="_Toc171978619" />
    <font face="Tahoma, sans-serif">
      <font size={5} style={{ fontSize: "18pt" }}>
        <span lang="en-US">6 – LPI Events</span>
      </font>
    </font>
  </h1>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978620" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        <span lang="en-US">6.1 INTERNATIONAL PAUPER TOUR (IPT)</span>
      </font>
    </font>
  </h2>
  <p >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        L’International Pauper Tour (IPT) è una valenza attribuibile e
        identificabile in tutti quei tornei organizzati dal circuito LPI che,
        non essendo conteggiabili né come tappa di Lega, hanno la prerogativa di
        invitare giocatori interni ed esterni alla Lega organizzatrice in un
        tour sul territorio italiano e le sue Leghe affiliate che ne organizzano
        uno.
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Ogni Lega può organizzare <b>solo e solamente 1 torneo IPT</b> per anno LPI rispettando i requisiti di seguito descritti, è concesso
        unire gli IPT di una o più leghe.
      </font>
    </font>
  </p>
  <p align="left">
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Per le leghe <b>estere</b> è possibile organizzare <b>2 IPT per anno LPI, con il limite di 1 IPT per season.</b> Anche per le leghe estere è possibile organizzare super IPT allo stesso
        modo, rispettando sempre il limite di 1 IPT per season.
      </font>
    </font>
  </p>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978621" />
    <font face="Tahoma, sans-serif">
      6.1.1 Requisiti essenziali (Minimun requirements)
    </font>
  </h3>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Un evento per essere considerato un International Pauper Tour deve:
      </font>
    </font>
  </p>
  <ul>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Avere un nome univoco, che lo renda riconoscibile come evento
              speciale.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p
        style={{
          
          orphans: 2,
          widows: 2,
          marginBottom: "0in"
        }}
      >
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              essere rigorosamente nel formato Pauper, nessun altro formato
              derivato è accettato per un IPT.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              essere sanzionato LPI, ovvero approvato dal Direttivo LPI, il
              quale darà parere favorevole a seconda della data proposta (anche
              indicativa) in virtù della programmazione di tutti gli eventi del
              circuito LPI preesistenti o già fissati, evitando così
              sovrapposizioni sul calendario generale;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              riportare nella locandina dell'evento i loghi ufficiali LPI e la
              dicitura distintiva IPT in modo che ogni giocatore possa
              riconoscerlo in maniera inequivocabile;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Essere pubblicizzato al meglio delle possibilità degli
              organizzatori dell'evento;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              fornire Judge proporzionati per l'evento, sia per qualità che per
              quantità
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              avere la disponibilità per un locale adeguato al numero di
              giocatori previsto, per un minimo di 33 giocatori.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              svolgersi nel proprio territorio di competenza, ovvero non
              delocalizzato rispetto alla propria comunità di giocatori;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              riportare nella descrizione dell'evento in modo esplicito che solo
              al raggiungimento di 33 giocatori saranno attributi i Ranking
              Points
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              non essere conteggiato come tappa di Lega e quindi per il calcolo
              della fascia Bye per il Paupergeddon;
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Premiare tassativamente almeno la Top8 a prescindere dal numero
              dei partecipanti.
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978622" />
    <font face="Tahoma, sans-serif">6.1.2 Montepremi (Prize pool)</font>
  </h3>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I premi sono decisi dal Referente di Lega responsabile del singolo IPT
        in relazione al numero di partecipanti all'evento, predisponendo sempre
        una griglia <b>garantita</b>.
      </font>
    </font>
  </p>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978623" />
    <font face="Tahoma, sans-serif">6.1.3 SUPER IPT e BYE EXTRA</font>
  </h3>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Al fine di incentivare la collaborazione tra le leghe ed ottimizzare la
        gestione degli eventi IPT, LPI conferisce lo stato di “super” ad IPT
        organizzato da <b>ALMENO 3 (tre) leghe.</b>
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Nel caso in prendano parte un numero di <b>
          giocatori superiore a 100 (cento) è assegnato al vincitore dell’evento
          un Bye,</b> non cumulabile, per il Paupergeddon immediatamente successivo al Super
          IPT.
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Per l'organizzazione del Super IPT sarà possibile definire un
        regolamento dell’evento nel quale prevedere forme di collaborazione
        (quali ad esempio: ticket di ingresso gratuiti, Bye, etc..).
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        L’organizzazione di un Super IPT è limitata all’area geografica di
        assegnazione delle singole leghe (vds. allegato 1 alla presente
        comunicazione) e deve essere approvato da tutti i referenti di area di
        riferimento.
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        L’organizzazione di un Super IPT utilizza lo slot a disposizione di
        tutte e tre le leghe per l’anno LPI in corso.
      </font>
    </font>
  </p>
  <h2 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978624" />
    <font face="Tahoma, sans-serif">
      <font size={4} style={{ fontSize: "14pt" }}>
        6.2 PAUPER TRIO EVENT (PTE)
      </font>
    </font>
  </h2>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il Pauper Trio Event (PTE) è una valenza attribuibile e identificabile a
        tutti quei tornei Team Constructed Unified – Pauper organizzati dal
        circuito LPI. Ogni Lega può organizzare <b>solo e solamente 1 torneo PTE</b> per anno LPI. 
      </font>
    </font>
  </p>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978625" />
    <font face="Tahoma, sans-serif">
      6.2.1 Requisiti essenziali (Minimun requirements)
    </font>
  </h3>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I requisiti sono al pari di un IPT, con l’eccezione di:
      </font>
    </font>
  </p>
  <ul>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              essere rigorosamente nel formato Team Constructed Unified –
              Pauper, nessun altro formato derivato è accettato per un IPT.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Premiare tassativamente almeno la Top4 dei team a prescindere dal
              numero dei partecipanti.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              avere la disponibilità per un locale adeguato al numero di
              giocatori previsto, per un minimo di 17 team.
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              riportare nella descrizione dell'evento in modo esplicito che solo
              al raggiungimento di 17 teams saranno attributi i Ranking Points
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <h3 className="western" style={{ orphans: 2, widows: 2 }}>
    <a name="_Toc171978626" />
    <font face="Tahoma, sans-serif">6.2.2 Montepremi (Prize pool)</font>
  </h3>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        I premi sono decisi dal Referente di Lega responsabile del singolo PTE
        in relazione al numero di partecipanti all'evento, predisponendo sempre
        una griglia <b>garantita</b>.
      </font>
    </font>
  </p>
  <p>
    <br />
  </p>
  <h1
    className="western"
    style={{ marginTop: "0in", pageBreakBefore: "always" }}
  >
    <a name="_Toc171978627" />
    <font face="Tahoma, sans-serif">
      <font size={5} style={{ fontSize: "18pt" }}>
        7 – Contatti (Contacts)
      </font>
    </font>
  </h1>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        LPI utilizza i seguenti strumenti informatici per comunicare e
        promuoversi:
      </font>
    </font>
  </p>
  <p style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        <span lang="en-US">- Website: </span>
      </font>
    </font>
    <a href="https://www.legapauperitalia.it">
      <font face="Tahoma, sans-serif">
        <font size={2} style={{ fontSize: "10pt" }}>
          <span lang="en-US">
            www.legapauperitalia.it
          </span>
        </font>
      </font>
    </a> 
  </p>
  <p style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        <span lang="en-US">- Rankings: </span>
      </font>
    </font>
    <a href="https://www.legapauperitalia.it/rankings">
      <font face="Tahoma, sans-serif">
        <font size={2} style={{ fontSize: "10pt" }}>
          <span lang="en-US">
            www.legapauperitalia.it/rankings
          </span>
        </font>
      </font>
    </a> 
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        <span lang="en-US">- Email: </span>
      </font>
    </font>
    <a href="mailto:lpauperitalia@gmail.com">
      <font face="Tahoma, sans-serif">
        <font size={2} style={{ fontSize: "10pt" }}>
          <span lang="en-US">
            lpauperitalia@gmail.com
          </span>
        </font>
      </font>
    </a>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        <span lang="en-GB">- Email for Payments: </span>
      </font>
    </font>
    <font color="#0563c1">
        <a href="mailto:vaultLPI@gmail.com">
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              <span lang="en-GB">vaultLPI@gmail.com</span>
            </font>
          </font>
        </a>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        <span lang="en-GB">- Telegram P4P:</span>
      </font>
    </font>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        <span lang="en-GB">
            <a href="https://web.telegram.org/z/#-1338645033">
              Pauper for the People
            </a>
        </span>
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        - Facebook:
      </font>
    </font>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
          <a href="https://www.facebook.com/legapauperitalia">
            @legapauperitalia
          </a>
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        - Profilo Twitch:
      </font>
    </font>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
          <a href="https://www.twitch.tv/legapauperitalia">
            twitch.tv/legapauperitalia
          </a>
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        - Youtube:{" "}
      </font>
    </font>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
          <a href="https://www.youtube.com/channel/UCBy9ND_PjdMo8MXQo7257-g/featured">
            Canale Lega Pauper Italia
          </a>{" "}
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        <span lang="en-GB">- Instagram: </span>
      </font>
    </font>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
            <a href="https://www.instagram.com/legapauperitalia_official/">
              legapauperitalia_official
            </a>
      </font>
    </font>
  </p>
  <p
    style={{
      
      orphans: 2,
      widows: 2,
      marginTop: "0in",
      marginBottom: "0in"
    }}
  >
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        <span lang="en-US">- Server Discord: </span>
      </font>
    </font>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
            <a href="https://discord.com/channels/688319712245186631/688319712953892899">
              link
            </a>
      </font>
    </font>
  </p>
  <p style={{  marginTop: "0in", marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        <span lang="en-US">- X/Twitter: </span>
      </font>
    </font>
  </p>
  <h1
    className="western"
    style={{ marginTop: "0in", pageBreakBefore: "always" }}
  >
    <a name="_Toc171978628" />
    <font face="Tahoma, sans-serif">
      <font size={5} style={{ fontSize: "18pt" }}>
        8 – FAQ{" "}
      </font>
    </font>
  </h1>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>Come posso ottenere un Bye?</b>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Puoi ottenere un Bye per un Paupergeddon nei seguenti modi:
      </font>
    </font>
  </p>
  <ul>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Tramite una lega, se la media dei giocatori nelle migliori 6 tappe
              è almeno pari a 16
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Tramite Super IPT, se il numero dei giocatori è almeno 100
            </font>
          </font>
        </font>
      </p>
    </li>
    <li>
      <p>
        <font size={3} style={{ fontSize: "12pt" }}>
          <font face="Tahoma, sans-serif">
            <font size={2} style={{ fontSize: "10pt" }}>
              Vincendo un Torneo Trial per il Paupergeddon
            </font>
          </font>
        </font>
      </p>
    </li>
  </ul>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Vincendo il Top Pauper Player (Bye cumulabile)
      </font>
    </font>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        {" "}
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>Perché avete deciso di far “scalare” il Bye?</b>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il Bye non è solo un premio al giocatore, ma riconoscimento all’ottimo
        lavoro svolto dalla lega. Abbiamo risposto alla evidente necessità delle
        leghe di non lasciare il Bye “sprecato”, falsando i risultati della
        finale di lega facendo risultare vincitore chi sarebbe andato al
        Paupergeddon, separando, in senso lato, i punti Ranking, ora legati
        all’invito TPP e propri del singolo giocatore, dal Bye, riconoscimento
        che LPI e la lega di riferimento garantisce al giocatore più forte che
        partecipa al Paupergeddon di riferimento.
        <br />
        Confidiamo comunque nella vostra buona fede nella gestione dei premi di
        lega
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <b>E come scala?</b>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Dall’anno 24/25 abbiamo deciso di far scalare il Bye, essendo
        quest’ultimo un coronamento non solo del percorso del giocatore ma della
        lega stessa.
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Ecco qualche esempio di come gestire il Bye:
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Thomas Perdita vince il Bye nella prestigiosa lega di
        Nerogiardini-Nyxtos, in quanto da regolamento interno assegna 2 Bye, uno
        per classifica, uno per Top8. <br />
        Thomas dopo le 6 tappe è primo in classifica ed ha diritto ad un Bye;
        gioca la Top8, come da regolamento ed arriva in finale: a prescindere
        dal risultato, entrambi i finalisti saranno assegnatari di Bye.
        <br />
        Thomas, colmo di tristezza, non potrà partecipare al Paupergeddon: il
        suo Bye “scala” al successivo, ovvero il terzo classificato durante la
        Top8.{" "}
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Nella stagione successiva, la lega è in crisi e assegna un solo Bye,
        come da regolamento interno tramite classifica. Thomas è sempre primo,
        assegnatario di Bye. La Top8 è comunque giocata per i premi e stavolta
        perde in finale, pur mantenendo il suo Bye.
        <br />
        Il matrimonio della cugina di Thomas è il giorno del Paupergeddon e
        anche questa volta non può partecipare, il Bye “scala” all’altro
        finalista, che però è proprio la cugina: il Bye “scala” ancora al
        successivo, ovvero il terzo classificato durante la Top8.{" "}
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Nella stagione successiva la lega decide di cambiare all’unanimità il
        regolamento interno e il Bye è assegnato solo tramite Top8. Thomas
        arriva primo in classifica, ma arriva quinto in Top8. Nessun giocatore
        della top4 può partecipare al Paupergeddon, quindi il “Bye” scala fino a
        lui.{" "}
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <b>
        Con il bye che scala, posso comunque ottenere due Bye non cumulabili?
      </b>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Sì, il Bye scala solamente all’interno della Top8 di lega. Se vinci due
        Bye da due leghe diverse, oppure hai un Bye già da un Super IPT e vinci
        successivamente una lega, non puoi far scalare il tuo Bye. Il doppio Bye
        sarà sprecato, però sei molto forte. Bella pe’ te.{" "}
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <b>Ho vinto la mia lega, oltre al Bye ho il biglietto gratuito?</b>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        No, a meno che lo preveda la lega non hai diritto ad un biglietto
        gratuito. Hai diretto però ad acquistare il biglietto in qualsiasi
        momento, terremo sempre un posto per te. Le quote di iscrizione LPI
        foraggiano la griglia premi degli eventi speciali LPI durante il
        Paupergeddon.
      </font>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>Per quale motivo avete dato più importanza al Ranking? (No!)</b>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il ranking resta solo uno strumento per visualizzare gli LPI Points.{" "}
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        La qualifica tramite LPI è lo strumento che useremo per premiare i
        giocatori che hanno realizzato i migliori risultati durante l’anno,
        incentivando, come già dimostrato, i giocatori a partecipare agli IPT e
        alle leghe durante le stagioni.{" "}
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Come LPI, spingeremo verso l’aspetto competitivo più sano possibile di
        questa classifica ed è anche il motivo per cui abbiamo scelto una
        qualificazione a soglia di punti e non a numero chiuso: il risultato che
        permette ad un giocatore di qualificarsi per il TPP non può togliere il
        posto ad un giocatore già qualificato.
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Non è la tua posizione nel ranking che permette la qualifica tramite
        IPT, ma i punti raccolti, i tuoi risultati.
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Notare che la vittoria di un TPP da 6 turni vale 300 punti, ovvero è
        equivalente all’invito che ti serve per difendere all’edizione
        successiva il titolo di campione.{" "}
      </font>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>
        Se non voglio i miei punti LPI siano pubblici, perderò la possibilità di
        qualificarmi agli eventi LPI?
      </b>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Qualsiasi giocatore che non voglia mostrare i suoi punti pubblicamente è
        libero di farlo, senza inficiare la partecipazione al TPP. La lista dei
        nomi completi dei giocatori qualificati al TPP verrà pubblicata solo a
        spring season chiusa.{" "}
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>Perché le leghe estere hanno 2 slot IPT a partire da questa season?</b>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Per le leghe estere è più difficile partecipare agli eventi LPI a causa
        della distanza, non hanno problemi di sovrapposizione degli eventi
        grazie alla bassa densità e promuovere più eventi all’estero può far
        crescere LPI fuori dai confini nazionali{" "}
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>La mia lega non assegna Bye a causa della media bassa, che faccio?</b>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Anche una season sotto il minimo di 16 di media aiuta a promuovere il
        formato. Anche se non assegni i Bye, da quest’anno, le finali di lega
        assegnano punti ranking e all’invito TPP al raggiungimento della soglia{" "}
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>Perché avete ridotto il numero di tappe da 7 (sette) a 6 (sei)?</b>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Con il crescente numero di IPT e leghe vicine, abbiamo preferito puntare
        alla qualità delle tappe che alla quantità, diminuendo il numero minimo
        di tappe ma aumentando la soglia di assegnazione dei Bye.
      </font>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        No, Wren ci ha obbligato.{" "}
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>Perché standardizzare il metodo di assegnazione dei Bye?</b>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Con il crescente numero di leghe, standardizzare significa snellire il
        processo di gestione, assegnando il Bye per Top8 e/o Classifica:
        qualsiasi altra opzione è soggetta ad un’approvazione di uno statuto
        speciale.
      </font>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Imporre che il vincitore della classifica sia obbligatoriamente incluso
        in una eventuale Top8 per i premi, ci evita di considerare delle Top9 e
        standardizzare le classifiche delle leghe. Invitiamo quelle pochissime
        leghe che operavano in questo modo a rivedere il sistema di attribuzione
        dei premi e contattarci per un eventuale supporto.{" "}
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>
        Perché le finali di lega hanno un moltiplicatore così alto? Contano più
        di un Paupergeddon?
      </b>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il numero di round non viene contato nelle finali di lega
        (moltiplicatore pari a 1). Infatti, il moltiplicatore di una finale di
        lega da 1 Bye è pari a 3.75, la metà rispetto ad un IPT da 6 turni.{" "}
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>Abbiamo vinto la Coppa del Mondo, come usiamo il Bye aggiuntivo?</b>
    </font>
  </p>
  <p>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        La prossima Season Competitiva a cui parteciperete, a prescindere dalla
        media, avrete un Bye aggiuntivo. Ricordiamo che se non diversamente
        specificato da vostro regolamento interno, questo Bye verrà assegnato
        tramite Top8.{" "}
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>
        Come segnalo un giocatore per comportamento avverso ai fini aggregativi
        a LPI?
      </b>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Puoi contattare il tuo referente di Lega, di Zona o la persona preposta
        alle sanzioni del direttivo LPI, in alternativa il senato Azorius.
      </font>
    </font>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        <b> </b>
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>Cosa è un PTE?</b>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Il PTE è a tutti gli effetti un IPT a squadre e vogliamo che rispecchi
        gli stessi standard di qualità. Nonostante il nome, Path To Exile non è
        legale in questo tipo di tornei e Ash Barrens Open non ha riscontrato il
        successo sperato in fase di scelta del nome.{" "}
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>Cosa essere l’anno Pauper?</b>
    </font>
  </p>
  <p align="left" style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        L’anno Pauper parte dopo il Paupergeddon di Pisa e finisce con quello
        dell’anno successivo compreso. Notare che i punti LPI si maturano a
        partire dal TPP di Pisa e fino al TPP successivo, escluso. 24 ore di
        sfasamento{" "}
      </font>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <b>Per tutto quello che non è esplicitato nel regolamento?</b>
    </font>
  </p>
  <p style={{  marginBottom: "0.04in" }}>
    <font face="Tahoma, sans-serif">
      <font size={2} style={{ fontSize: "10pt" }}>
        Se hai ancora dubbi sul regolamento, rileggi il regolamento. Poi fallo
        di nuovo. Se hai ancora dubbi, chiedi al tuo referente di Lega, poi di
        Zona. In generale si fa riferimento al codice penale-civile della
        nazione che ospita la lega, quindi evitate omicidi premeditati, evasione
        fiscale, insider trading, gioco d’azzardo, premi in denaro, meta con
        ponza tier 1.
      </font>
    </font>
  </p>
  </div>
          </Card>
        </Col>
      </Row>
  </motion.div>
    );
}

export default Rulebook;